export default "__VITE_ASSET__DjONZVOD__"